import * as React from 'react';
import isEmpty from 'lodash/isEmpty';
import { toast } from '@grandvisionhq/common';
import { useIntl, useSelector } from '@grandvisionhq/state';
import { useSyncCartShippingMethodWithReduxAfterTabFocus } from '../hooks/carts/use-sync-cart-shipping-method-with-redux.js';
import { useSetCustomerDetails } from '../hooks/operations/use-set-customer-details.js';
import { getSelectedShippingMethod, getSelectedStore, getServiceStore, getSelectedPickupPoint, isShippingStepValid } from '../StepShipping/selectors.js';
import { usePrepareCustomerDetails } from './hooks/use-prepare-customer-details.js';
import { StepOverview } from './StepOverview.js';
import { isPickupStore, isPickupPoint } from '../utils/shipping-method.js';

const StepOverviewContainer = (props)=>{
    var ref;
    const { onNextStep , onPrevStep , shippingMethodsAsides  } = props;
    const { getLabel  } = useIntl();
    const { customerDetails  } = usePrepareCustomerDetails();
    const onCompleted = React.useCallback((operation)=>{
        // The payment page needs the fresh cart data.
        // If we want to ditch redux, everything should rely on apollo
        operation === 'MUTATION' && onNextStep();
    }, [
        onNextStep
    ]);
    const { setCustomerDetails  } = useSetCustomerDetails({
        onCompleted,
        onError: ()=>{
            toast.failed('checkout.errors.form.general');
        }
    });
    useSyncCartShippingMethodWithReduxAfterTabFocus();
    const onNextClick = ()=>{
        if (!isShippingStepValid$1) {
            onPrevStep();
        } else if (customerDetails && !isEmpty(customerDetails)) {
            setCustomerDetails(customerDetails);
        }
    };
    const selectedShippingMethod = (ref = useSelector(getSelectedShippingMethod)) === null || ref === void 0 ? void 0 : ref.method;
    const selectedStore = useSelector(getSelectedStore);
    const serviceStore = useSelector(getServiceStore);
    const selectedPickupPoint = useSelector(getSelectedPickupPoint);
    const isShippingStepValid$1 = useSelector(isShippingStepValid);
    const isPickupStore$1 = isPickupStore(selectedShippingMethod);
    const isPickupPoint$1 = isPickupPoint(selectedShippingMethod);
    const labels = React.useMemo(()=>({
            generic: {
                title: getLabel('checkout.generic.title')
            },
            yourDetails: getLabel('checkout.yourDetails'),
            billingAddress: getLabel('checkout.billingAddress'),
            completed: {
                shipmentDetailsDelivery: getLabel('checkout.completed.shipmentDetails.delivery')
            },
            contactTitle: getLabel('checkout.contact.title'),
            customerTypeCompany: getLabel('checkout.customerType.company'),
            serviceStoreTitle: getLabel('checkout.serviceStore.title'),
            shipmentAddress: getLabel('checkout.shipment.address'),
            summary: {
                delivery: getLabel('checkout.summary.shipment.delivery'),
                deliveryExpress: getLabel('checkout.summary.shipment.deliveryExpress'),
                pickupStore: getLabel('checkout.summary.shipment.pickup'),
                pickupPoint: getLabel('checkout.summary.shipment.pickupPoint'),
                nearestPickup: getLabel('checkout.summary.shipment.nearestPickup'),
                address: getLabel('checkout.summary.shipment.address'),
                deliveryPremium: getLabel('checkout.summary.shipment.deliveryPremium')
            },
            editModal: {
                save: getLabel('common.actions.save')
            },
            differentDeliveryAddress: getLabel('checkout.shipment.differentDeliveryAddress'),
            nearestPickupMessage: getLabel('checkout.summary.shipment.nearestPickup.message')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(StepOverview, {
        cartComponent: props.cartComponent,
        isPickupPoint: isPickupPoint$1,
        isPickupStore: isPickupStore$1,
        labels: labels,
        onEdit: onPrevStep,
        onNextClick: onNextClick,
        onPrevClick: onPrevStep,
        selectedPickupPoint: selectedPickupPoint,
        selectedStore: selectedStore,
        serviceStore: serviceStore,
        shippingMethod: selectedShippingMethod,
        shippingMethodsAsides: shippingMethodsAsides
    });
};

export { StepOverviewContainer };
//# sourceMappingURL=StepOverviewContainer.js.map
